import {
    DTOCardFormField,
} from 'app/types/form.types'

import {
    ServiceCenterFormType,
} from '../serviceCenters.types'

const fields: DTOCardFormField<keyof ServiceCenterFormType>[] = [
    {
        id: 'serviceCenterMetrics',
        title: 'Service Center Metrics',
        className: 'serviceCenterMetrics',
        fields: [{
            id: 'serviceCenterMetrics-column1',
            fields: [
                {
                    name: 'orderSelectionDelay',
                    componentName: 'IntegerInput',
                    required: true,
                    labelKey: 'ServiceCenter.orderSelectionDelay',
                },
                {
                    name: 'maxTrucksPerDay',
                    componentName: 'IntegerInput',
                    required: true,
                    labelKey: 'ServiceCenter.maxTrucksPerDay',
                },
                {
                    name: 'processingThroughput',
                    componentName: 'IntegerInput',
                    required: true,
                    labelKey: 'ServiceCenter.processingThroughput',
                },
            ],
        }],
    },
    {
        id: 'productMetrics',
        title: 'Product Metrics',
        className: 'productMetrics',
        fields: [{
            name: 'productMetrics',
            componentName: 'ProductMetrics',
            exists: true,
            required: true,
            disabledFields: {
                productType: true,
                safeMinimumUsableStock: true,
            },
        }],
    },
    {
        id: 'storages',
        title: 'Storages',
        className: 'storages',
        fields: [{
            name: 'storages',
            componentName: 'Storages',
            showFields: {
                dailyPreconditioningCapacity: true,
            },
            exists: true,
            required: true,
            disabled: true,
        }],
    },
]

export default fields
